<template>
    <div>
        <div
            class="d-flex flex-column mb-3 p-2 rounded"
            :class="{ 'border border-danger': hasError }"
        >
            <div class="d-flex flex-column flex-md-row align-items-center w-100">
                <b-button
                    v-b-modal.signature-modal
                    variant="primary"
                    :disabled="isSignatureSaved"
                    v-if="isModalOpenButton"
                    class="w-100 w-md-auto mb-2 mb-md-0 mr-md-2"
                >
                    <i class="ri-pen-nib-line mr-2"></i>
                    {{$t('draw_signature')}}
                </b-button>

                <b-button
                    v-if="isSignatureSaved"
                    v-b-modal.signature-modal
                    variant="outline-primary"
                    class="w-100 w-md-auto"
                >
                    <i class="ri-edit-line mr-2"></i>
                    {{ $t('edit') }}
                </b-button>
            </div>

            <span v-if="hasError" class="text-danger small  mt-2 text-left">
                {{ $t('This field is required') }}
        </span>

        </div>
        <div v-if="savedSignatureImage" class="signature-preview-card mb-3">
            <h6 class="text-muted mb-2 small text-uppercase font-weight-bold">
                <i class="ri-file-shield-line"></i> {{$t('signed_document_preview')}}
            </h6>
            <div class="signature-image-container">
                <img :src="savedSignatureImage" alt="User Signature" class="img-fluid" />
            </div>
            <div class="mt-2 text-success small">
                <i class="ri-checkbox-circle-fill"></i> {{$t('signature_captured_successfully')}}
            </div>
        </div>

        <b-modal
            id="signature-modal"
            size="lg"
            centered
            @ok="handleSave"
            @shown="onModalShown"
            :ok-title="$t('save') "
            :cancel-title="$t('cancel')"

        >
            <ValidationObserver ref="signatureForm">
                <ValidationProvider rules="required" name="Signature" v-slot="{ errors }">
                    <div class="signature-wrapper" :class="{ 'error-border': errors.length > 0 }">
                        <VueSignaturePad
                            ref="signaturePad"
                            width="100%"
                            height="300px"
                            :options="{ penColor: '#000080', onEnd: onEndDrawing}"
                        />
                    </div>
                    <div class="d-flex justify-content-end mt-2">

                        <b-button size="sm" variant="outline-secondary" class="mr-2" @click="undo">
                            <i class="ri-arrow-go-back-line mr-1"></i> {{$t('rollback')}}
                        </b-button>

                        <b-button size="sm" variant="outline-danger" @click="clear">
                            <i class="ri-delete-bin-line mr-1"></i> {{ $t('clear') }}
                        </b-button>
                    </div>
                    <span v-if="errors[0]" class="text-danger small mt-1 d-block">
                    <i class="ri-error-warning-line"></i> Signature is required.
                     </span>
                    <input type="hidden" v-model="signatureData" />
                </ValidationProvider>
            </ValidationObserver>
        </b-modal>
    </div>
</template>

<script>
import { ValidationObserver, ValidationProvider} from 'vee-validate';

export default {
    components: {
        ValidationObserver,
        ValidationProvider
    },
    props:{
      isModalOpenButton:{
          type: Boolean,
          default: true
      },
    },
    data() {
        return {
            signatureData: '',
            savedSignatureImage: null,
            isSignatureSaved: false,
            hasError: false
        };
    },
    watch: {
        isSignatureSaved(val) {
            if(val) this.hasError = false;
        }
    },
    methods: {
        clear() {
            if (this.$refs.signaturePad) {
                this.$refs.signaturePad.clearSignature();
                this.onEndDrawing();
            }
        },
        undo() {
            if (this.$refs.signaturePad) {
                this.$refs.signaturePad.undoSignature();
            }
        },
        validate() {
            if (!this.isSignatureSaved || !this.savedSignatureImage) {
                this.hasError = true;
                // this.$toast.error('Signature is required!');
                return false;
            }
            this.hasError = false;
            return true;
        },

        onModalShown() {
            this.hasError = false;

            this.$nextTick(() => {
                if (this.$refs.signaturePad) {
                    this.$refs.signaturePad.resizeCanvas();
                    this.$refs.signaturePad.clearSignature();
                    this.signatureData = '';
                    if(this.$refs.signatureForm) this.$refs.signatureForm.reset();
                }
            });
        },
        onEndDrawing() {
            const { isEmpty, data } = this.$refs.signaturePad.saveSignature();

            this.signatureData = isEmpty ? '' : data;
        },
        async handleSave(bvModalEvent) {
            bvModalEvent.preventDefault();
            const isValid = await this.$refs.signatureForm.validate();

            if (!isValid) {
                this.$toast.error('Please provide a signature first!');
                return;
            }
            this.savedSignatureImage = this.signatureData;
            this.isSignatureSaved = true;
            this.hasError = false;

            this.$nextTick(() => {
                this.$bvModal.hide('signature-modal');
                this.$toast.success(this.$t('proccess_success'))
            });
            const file = new File(
                [Uint8Array.from(atob(this.signatureData.split(',')[1]), (m) => m.codePointAt(0))],
                'signature.png',
                { type: 'image/png' }
            );

            this.$emit('input', file);
        }
    }
};
</script>

<style scoped>
.signature-wrapper {
    border: 2px dashed #ccc;
    background-color: #f9f9f9;
    border-radius: 4px;
    overflow: hidden;
    cursor: crosshair;
}
.signature-wrapper.error-border {
    border-color: #dc3545;
    background-color: #fff5f5;
}
.signature-preview-card {
    max-width: 400px;
    background: #fff;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    padding: 15px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}
.signature-image-container {
    border-bottom: 2px solid #000;
    padding-bottom: 5px;
    text-align: center;
}
.signature-image-container img {
    max-height: 100px;
    width: auto;
}
</style>
